import React from 'react'

const PaperclipBlackSvg = ({ width }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      viewBox='0 0 13.884 13.848'
    >
      <g
        id='style_linear'
        data-name='style=linear'
        transform='translate(-2.6 -2.4)'
      >
        <g id='attach' transform='translate(3.35 3.15)'>
          <path
            id='vector'
            d='M15.423,8.361,9.307,14.476A3.49,3.49,0,0,1,4.372,9.541l5.676-5.676A2.443,2.443,0,1,1,13.5,7.32l-5.44,5.44a1.4,1.4,0,0,1-1.974-1.974L11.11,5.764'
            transform='translate(-3.35 -3.15)'
            fill='none'
            stroke='#000'
            strokeLinecap='round'
            strokeWidth='1.5'
          />
        </g>
      </g>
    </svg>
  )
}

export default PaperclipBlackSvg
